import React from "react";
import general from "../../../../../general";

export default function ServiceBar({ gameid }) {
  return (
    <div className="imc-service-bar">
      <div
        className="imc-service-btn"
        onClick={() => general.history.push("/service")}
      >
        <img src="resources/im/service.png" alt="" />
        <span>联系客服</span>
      </div>
      {gameid && (
        <div
          className="imc-service-btn"
          onClick={() => general.history.push(`/detailTrade?id=${gameid}`)}
        >
          <img src="resources/250410/trade.png" alt="" />
          <span>账号交易</span>
        </div>
      )}
    </div>
  );
}
